import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Grid, Paper, CssBaseline, Button,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Header from '../Includes/Header';
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { useSearchParams, useNavigate } from 'react-router-dom';

const months = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const MonthCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
  cursor: 'pointer',
  background: 'white',
  transition: 'all 0.25s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 8px 24px rgba(27,67,50,0.15)',
    background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
    '& .month-title': { color: 'white' },
    '& .month-sub': { color: 'rgba(255,255,255,0.7)' },
    '& .month-icon': { color: 'white' },
  },
}));

const MonthlyAttendanceOverview = () => {
  const { colors: appColors } = useAppTheme();
  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const id = searchParams.get('userId');
    const name = searchParams.get('userName');
    if (id) setUserId(id);
    if (name) setUserName(name);
  }, [searchParams]);

  const handleMonthClick = (month, index) => {
    const year = new Date().getFullYear();
    const monthNum = (index + 1).toString().padStart(2, '0');
    navigate(
      `/monthly-attendance-detail?userId=${userId}&userName=${encodeURIComponent(userName)}&month=${year}-${monthNum}&monthName=${month}`
    );
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f3f4f6' }}>
      <CssBaseline />
      <Box><Header /></Box>

      <Box component="main" sx={{ flexGrow: 1, p: { xs: 2, sm: 3, md: 4 }, mt: { xs: 8, sm: 9 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4, flexWrap: 'wrap', gap: 2 }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{ borderColor: appColors.evergreen, color: appColors.evergreen, '&:hover': { backgroundColor: 'rgba(27,67,50,0.08)' } }}
          >
            Back
          </Button>
          <Typography variant="h5" sx={{ fontWeight: 700, color: appColors.evergreen }}>
            Monthly Attendance — {userName}
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {months.map((month, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={index}>
              <MonthCard elevation={1} onClick={() => handleMonthClick(month, index)}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5, gap: 1 }}>
                  <CalendarTodayIcon className="month-icon" sx={{ fontSize: 22, color: appColors.evergreen }} />
                  <Typography className="month-title" variant="h6" sx={{ fontWeight: 600, color: appColors.evergreen }}>
                    {month}
                  </Typography>
                </Box>
                <Typography className="month-sub" variant="body2" color="text.secondary">
                  View attendance details
                </Typography>
              </MonthCard>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default MonthlyAttendanceOverview;
